export type BiometricsProps = {
    onSubmit: (isFailedVerification?: boolean) => Promise<boolean>;
    isLoading: boolean;
    errorProceedText?: string;
};

export enum SelfieStepEnum {
    INFO = 'info',
    LIVENESS = 'liveness',
    SUCCESS = 'success',
}
